module.exports = __webpack_public_path__ + "media/images/help/about/icon-reason-1-9c0a7a81299dc2008ba24c9756316d68.svg";